// extracted by mini-css-extract-plugin
module.exports = {"container":"container--PostToSegment-routes__lLLL0"};